
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rules/formats",
      function () {
        return require("private-next-pages/rules/formats.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rules/formats"])
      });
    }
  